import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginPageComponent } from './core/components/login-page/login-page.component';
import { MainComponent } from './core/components/main/main.component';
import { SaleRacketsComponent } from './features/kurashima/components/sale-rackets/sale-rackets.component';

const routes: Routes = [
  // ===== HỆ THỐNG QUẢN LÝ (đường dẫn bí mật) =====
  {
    path: 'fox-admin/login',
    component: LoginPageComponent,
  },
  {
    path: 'fox-admin',
    component: MainComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/kurashima/kurashima.module').then(
            (mod) => mod.KurashimasModule
          ),
      },
    ],
  },

  // ===== Tra cứu giá (công cụ riêng) =====
  {
    path: 'sale',
    component: SaleRacketsComponent,
  },

  // ===== TRANG PUBLIC (mặc định, không cần đăng nhập) =====
  {
    path: '',
    loadChildren: () =>
      import('./features/public/public.module').then((mod) => mod.PublicModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
